import { defineComponent as d, createElementBlock as t, openBlock as e, createElementVNode as i, renderSlot as k, unref as o, createBlock as a } from "vue";
import { ScalarIconSun as g, ScalarIconMoon as u } from "@scalar/icons";
import { useColorMode as p } from "@scalar/use-hooks/useColorMode";
const m = { class: "dark-light-toggle-layout" }, _ = {
  key: 2,
  class: "dark-light-label"
}, f = {
  key: 3,
  class: "dark-light-label"
}, C = /* @__PURE__ */ d({
  __name: "DarkModeToggle",
  setup(h) {
    const { toggleColorMode: l, isDarkMode: r } = p();
    return (s, n) => (e(), t("div", m, [
      i("button", {
        class: "dark-light-toggle icon-button",
        type: "button",
        onClick: n[0] || (n[0] = //@ts-ignore
        (...c) => o(l) && o(l)(...c))
      }, [
        o(r) ? (e(), a(o(g), { key: 0 })) : (e(), a(o(u), { key: 1 })),
        o(r) ? (e(), t("span", _, " Light Mode ")) : (e(), t("span", f, " Dark Mode "))
      ]),
      k(s.$slots, "default", {}, void 0, !0)
    ]));
  }
});
export {
  C as default
};
